import { Star, Users, ThumbsUp } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function SocialProofBanner() {
  const { content } = useContent();
  const sections = content?.sections || {};
  const items = [
    { icon: Star, text: sections.social_proof_1 || "100% Recommend · 8 Reviews", testid: "social-proof-1" },
    { icon: Users, text: sections.social_proof_2 || "859 Followers on Facebook", testid: "social-proof-2" },
    { icon: ThumbsUp, text: sections.social_proof_3 || "Honest Bids · On-Time Delivery", testid: "social-proof-3" },
  ].filter((it) => it.text && it.text.trim());

  if (!items.length) return null;

  return (
    <section
      data-testid="social-proof-banner"
      className="bg-[#84FB00] border-y border-black/20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex flex-col md:flex-row items-center justify-between gap-4 text-black">
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-3 font-display tracking-widest uppercase text-sm md:text-base">
            <it.icon size={18} strokeWidth={2.5} />
            <span data-testid={it.testid}>{it.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
